/**
 * Menu script
 */
class Clinic_Menu {
    constructor() {
        this.menuIsSticky = false;
        this.initState();
        this.initEvents();
        this.initStickyDetection();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');        
    }

    initEvents() {
        this.menuIcon.attr('aria-expanded', 'false');

        this.menuIcon.on('click', e => {
            let menuIconState = this.menuIcon.attr('aria-expanded');

            if (menuIconState === 'true' ) {
                this.menuIcon.attr('aria-expanded', 'false');
                this.menuIcon.text(this.menuIcon.attr('data-closed-text'));
            } else {
                this.menuIcon.attr('aria-expanded', 'true');
                this.menuIcon.text(this.menuIcon.attr('data-open-text'));
            }
        });
    }

    initStickyDetection () {
        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 20 && !this.menuWrapper.hasClass('is-sticky')) {
                this.menuWrapper.addClass('is-sticky');
                return;
            }

            if (positionY <= 20 && this.menuWrapper.hasClass('is-sticky')) {
                this.menuWrapper.removeClass('is-sticky');
            }
        });

        $(window).trigger('scroll');
    }

    setStickyState () {
        if (this.menuIsSticky) {
            $('.site-header').addClass('is-sticky');
        } else {
            $('.site-header').removeClass('is-sticky');
        }
    }
}
